<h2 mat-dialog-title>{{title}}</h2>
@if (busy) {
  <div class="overlay">
    <div class="center">
      <mat-spinner>
      </mat-spinner>
    </div>
  </div>
}
<mat-dialog-content>
  @if(auctionType==2){
    @if (!resultReceived) {
        <div class="w-100 flex-col justify-center items-center mt-3">
          <span>I want to offer</span>
          <span class="amount">{{bidAmount | currency : 'USD' : 'symbol' : '1.2'}}</span>
          <span>for this property</span>
          <span class="mt-3">Auction accepts one offer every {{defaultOfferTimeOutMinutes}} minutes</span>
        </div>
      }
      @else {
        <div class="w-100 flex-col justify-center items-center mt-3">
          <span>{{resultText}}</span>
          @if (showCounterOffer) {
            <countdown class="ml-2 primary-color" #countdown  [config]="{leftTime: askAmountExclusivitySeconds}" ></countdown>
            <span class="amount">{{askAmount | currency : 'USD' : 'symbol' : '1.2'}}</span>
            <mat-progress-bar mode="determinate" [value]="progressbarValue"></mat-progress-bar>
          }
        </div>
      }
  }
  @else if(auctionType==3 || auctionType==4){
    <app-buyer-legal-document [documentTemplate]="documentTemplate" [internal]="false" (onDocumentExecuted)="legalDocumentExecuted($event)"></app-buyer-legal-document>
  }
  
</mat-dialog-content>

<mat-dialog-actions>
  <div class="w-100 flex-row space-between items-center mt-3 p-2">
    @if (!hideConfirmButton && canSubmit) {
      <button mat-flat-button class="w-50" color="primary" (click)="onConfirmClick()" >{{confirmButtonText}}</button>
    }
    @if (canCancel) {
      <button [ngClass]="(hideConfirmButton || (resultReceived && !showCounterOffer))?'w-100':'w-50'" mat-flat-button color="primary" (click)="onCancelClick()" >{{cancelButtonText}}</button>
    }
    @if (showCounterOffer) {
      <button mat-flat-button class="w-50" color="primary" (click)="onAcceptClick()" >{{acceptButtonText}}</button>
    }
  </div>
</mat-dialog-actions>

